const codes = {
  enter: 13,
  tab: 9,
  space: 32
};

export default codes;



// WEBPACK FOOTER //
// ./src/keyCodes.js